export const findFile = (fileList, fileName) => {
  for (let i = 0; i < fileList.length; i++) {
    const file = fileList[i]
    if (file.name.indexOf(fileName) >= 0) {
      return file
    }
  }
}

export const pascalToCamel = pascal => pascal.substring(0, 1).toLowerCase() + pascal.substring(1, pascal.length)

export const getEventType = event => {
  switch (event.event) {
    case 'START':
      return 'start'
    case 'STOP':
      return 'stop'
    case 'LB_CLICK':
    case 'MB_CLICK':
    case 'RB_CLICK':
      return 'click'
    case 'LB_DBL_CLICK':
    case 'MB_DBL_CLICK':
    case 'RB_DBL_CLICK':
      return 'd-click'
    case 'LB_DRAG_START':
    case 'MB_DRAG_START':
    case 'RB_DRAG_START':
      return 'drag-start'
    case 'LB_DRAG_END':
    case 'MB_DRAG_END':
    case 'RB_DRAG_END':
      return 'drag-end'
    case 'MOUSE_WHEEL_START_SCROLL':
      return 'scroll-start'
    case 'MOUSE_WHEEL':
      return 'scroll'
    case 'MOUSE_WHEEL_END_SCROLL':
      return 'scroll-end'
    case 'KEYPRESS':
      return 'key'
  }
}

export const isPassed = (event, activeEventNr) => {
  const eventNr = parseInt(event.key)
  return eventNr < activeEventNr
}

export const isActive = (event, activeEventNr) => {
  const eventNr = parseInt(event.key)
  return eventNr === activeEventNr
}

export const formatTime = timeInMs => {
  const totalSeconds = timeInMs / 1000
  const minutes = Math.floor(totalSeconds / 60)
  const minutesStr = minutes < 10 ? '0' + minutes.toFixed(0) : '' + minutes.toFixed(0)
  const seconds = Math.floor(totalSeconds - 60 * minutes)
  const secondsStr = seconds < 10 ? '0' + seconds.toFixed(0) : '' + seconds.toFixed(0)
  return minutesStr + ':' + secondsStr
}

export const formatNumber = (number, nrOfDecimals = 2) => {
  const numberStr = number.toFixed(nrOfDecimals)
  let formattedString = ''
  let count = 0
  for (let i = numberStr.length - 1; i >= 0; i--) {
    if (count === 3) {
      formattedString = ',' + formattedString
      count = 0
    }
    formattedString = numberStr.charAt(i) + formattedString
    count = count + 1
  }
  return formattedString
}

export const round = nmbr => Math.round(nmbr * 10) / 10
